import { isTouch } from '../util/isTouch';

export type SubsidySymbol = {
  open: boolean;
  isTouch: boolean;
};

function subsidySymbol(): SubsidySymbol {
  return {
    open: false,
    isTouch,
  };
}

window.subsidySymbol = subsidySymbol;
